// Liste officielle des 114 sourates du Coran (ordre du Mushaf).
// Chaque entrée : { num, name (fr/translit), name_ar }
export const SOURATES = [
  { num: 1, name: "Al-Fatiha", name_ar: "الفاتحة" },
  { num: 2, name: "Al-Baqara", name_ar: "البقرة" },
  { num: 3, name: "Al-Imran", name_ar: "آل عمران" },
  { num: 4, name: "An-Nisa", name_ar: "النساء" },
  { num: 5, name: "Al-Ma'ida", name_ar: "المائدة" },
  { num: 6, name: "Al-An'am", name_ar: "الأنعام" },
  { num: 7, name: "Al-A'raf", name_ar: "الأعراف" },
  { num: 8, name: "Al-Anfal", name_ar: "الأنفال" },
  { num: 9, name: "At-Tawba", name_ar: "التوبة" },
  { num: 10, name: "Yunus", name_ar: "يونس" },
  { num: 11, name: "Hud", name_ar: "هود" },
  { num: 12, name: "Yusuf", name_ar: "يوسف" },
  { num: 13, name: "Ar-Ra'd", name_ar: "الرعد" },
  { num: 14, name: "Ibrahim", name_ar: "إبراهيم" },
  { num: 15, name: "Al-Hijr", name_ar: "الحجر" },
  { num: 16, name: "An-Nahl", name_ar: "النحل" },
  { num: 17, name: "Al-Isra", name_ar: "الإسراء" },
  { num: 18, name: "Al-Kahf", name_ar: "الكهف" },
  { num: 19, name: "Maryam", name_ar: "مريم" },
  { num: 20, name: "Ta-Ha", name_ar: "طه" },
  { num: 21, name: "Al-Anbiya", name_ar: "الأنبياء" },
  { num: 22, name: "Al-Hajj", name_ar: "الحج" },
  { num: 23, name: "Al-Mu'minun", name_ar: "المؤمنون" },
  { num: 24, name: "An-Nur", name_ar: "النور" },
  { num: 25, name: "Al-Furqan", name_ar: "الفرقان" },
  { num: 26, name: "Ash-Shu'ara", name_ar: "الشعراء" },
  { num: 27, name: "An-Naml", name_ar: "النمل" },
  { num: 28, name: "Al-Qasas", name_ar: "القصص" },
  { num: 29, name: "Al-'Ankabut", name_ar: "العنكبوت" },
  { num: 30, name: "Ar-Rum", name_ar: "الروم" },
  { num: 31, name: "Luqman", name_ar: "لقمان" },
  { num: 32, name: "As-Sajda", name_ar: "السجدة" },
  { num: 33, name: "Al-Ahzab", name_ar: "الأحزاب" },
  { num: 34, name: "Saba", name_ar: "سبأ" },
  { num: 35, name: "Fatir", name_ar: "فاطر" },
  { num: 36, name: "Ya-Sin", name_ar: "يس" },
  { num: 37, name: "As-Saffat", name_ar: "الصافات" },
  { num: 38, name: "Sad", name_ar: "ص" },
  { num: 39, name: "Az-Zumar", name_ar: "الزمر" },
  { num: 40, name: "Ghafir", name_ar: "غافر" },
  { num: 41, name: "Fussilat", name_ar: "فصلت" },
  { num: 42, name: "Ash-Shura", name_ar: "الشورى" },
  { num: 43, name: "Az-Zukhruf", name_ar: "الزخرف" },
  { num: 44, name: "Ad-Dukhan", name_ar: "الدخان" },
  { num: 45, name: "Al-Jathiya", name_ar: "الجاثية" },
  { num: 46, name: "Al-Ahqaf", name_ar: "الأحقاف" },
  { num: 47, name: "Muhammad", name_ar: "محمد" },
  { num: 48, name: "Al-Fath", name_ar: "الفتح" },
  { num: 49, name: "Al-Hujurat", name_ar: "الحجرات" },
  { num: 50, name: "Qaf", name_ar: "ق" },
  { num: 51, name: "Adh-Dhariyat", name_ar: "الذاريات" },
  { num: 52, name: "At-Tur", name_ar: "الطور" },
  { num: 53, name: "An-Najm", name_ar: "النجم" },
  { num: 54, name: "Al-Qamar", name_ar: "القمر" },
  { num: 55, name: "Ar-Rahman", name_ar: "الرحمن" },
  { num: 56, name: "Al-Waqi'a", name_ar: "الواقعة" },
  { num: 57, name: "Al-Hadid", name_ar: "الحديد" },
  { num: 58, name: "Al-Mujadila", name_ar: "المجادلة" },
  { num: 59, name: "Al-Hashr", name_ar: "الحشر" },
  { num: 60, name: "Al-Mumtahana", name_ar: "الممتحنة" },
  { num: 61, name: "As-Saff", name_ar: "الصف" },
  { num: 62, name: "Al-Jumu'a", name_ar: "الجمعة" },
  { num: 63, name: "Al-Munafiqun", name_ar: "المنافقون" },
  { num: 64, name: "At-Taghabun", name_ar: "التغابن" },
  { num: 65, name: "At-Talaq", name_ar: "الطلاق" },
  { num: 66, name: "At-Tahrim", name_ar: "التحريم" },
  { num: 67, name: "Al-Mulk", name_ar: "الملك" },
  { num: 68, name: "Al-Qalam", name_ar: "القلم" },
  { num: 69, name: "Al-Haqqa", name_ar: "الحاقة" },
  { num: 70, name: "Al-Ma'arij", name_ar: "المعارج" },
  { num: 71, name: "Nuh", name_ar: "نوح" },
  { num: 72, name: "Al-Jinn", name_ar: "الجن" },
  { num: 73, name: "Al-Muzzammil", name_ar: "المزمل" },
  { num: 74, name: "Al-Muddaththir", name_ar: "المدثر" },
  { num: 75, name: "Al-Qiyama", name_ar: "القيامة" },
  { num: 76, name: "Al-Insan", name_ar: "الإنسان" },
  { num: 77, name: "Al-Mursalat", name_ar: "المرسلات" },
  { num: 78, name: "An-Naba", name_ar: "النبأ" },
  { num: 79, name: "An-Nazi'at", name_ar: "النازعات" },
  { num: 80, name: "'Abasa", name_ar: "عبس" },
  { num: 81, name: "At-Takwir", name_ar: "التكوير" },
  { num: 82, name: "Al-Infitar", name_ar: "الانفطار" },
  { num: 83, name: "Al-Mutaffifin", name_ar: "المطففين" },
  { num: 84, name: "Al-Inshiqaq", name_ar: "الانشقاق" },
  { num: 85, name: "Al-Buruj", name_ar: "البروج" },
  { num: 86, name: "At-Tariq", name_ar: "الطارق" },
  { num: 87, name: "Al-A'la", name_ar: "الأعلى" },
  { num: 88, name: "Al-Ghashiya", name_ar: "الغاشية" },
  { num: 89, name: "Al-Fajr", name_ar: "الفجر" },
  { num: 90, name: "Al-Balad", name_ar: "البلد" },
  { num: 91, name: "Ash-Shams", name_ar: "الشمس" },
  { num: 92, name: "Al-Layl", name_ar: "الليل" },
  { num: 93, name: "Ad-Duha", name_ar: "الضحى" },
  { num: 94, name: "Ash-Sharh", name_ar: "الشرح" },
  { num: 95, name: "At-Tin", name_ar: "التين" },
  { num: 96, name: "Al-'Alaq", name_ar: "العلق" },
  { num: 97, name: "Al-Qadr", name_ar: "القدر" },
  { num: 98, name: "Al-Bayyina", name_ar: "البينة" },
  { num: 99, name: "Az-Zalzala", name_ar: "الزلزلة" },
  { num: 100, name: "Al-'Adiyat", name_ar: "العاديات" },
  { num: 101, name: "Al-Qari'a", name_ar: "القارعة" },
  { num: 102, name: "At-Takathur", name_ar: "التكاثر" },
  { num: 103, name: "Al-'Asr", name_ar: "العصر" },
  { num: 104, name: "Al-Humaza", name_ar: "الهمزة" },
  { num: 105, name: "Al-Fil", name_ar: "الفيل" },
  { num: 106, name: "Quraysh", name_ar: "قريش" },
  { num: 107, name: "Al-Ma'un", name_ar: "الماعون" },
  { num: 108, name: "Al-Kawthar", name_ar: "الكوثر" },
  { num: 109, name: "Al-Kafirun", name_ar: "الكافرون" },
  { num: 110, name: "An-Nasr", name_ar: "النصر" },
  { num: 111, name: "Al-Masad", name_ar: "المسد" },
  { num: 112, name: "Al-Ikhlas", name_ar: "الإخلاص" },
  { num: 113, name: "Al-Falaq", name_ar: "الفلق" },
  { num: 114, name: "An-Nas", name_ar: "الناس" },
];

export const LEVEL_LABELS = ["Aucun", "Débutant", "Intermédiaire", "Confirmé", "Avancé", "Bilingue"];
